import React from "react"
import styled from "styled-components"
import SkeletonLoader from "./SkeletonLoader"
import { useAvatar } from "../hooks/useAvatar"
import { getHeaderTheme } from "../config/headerTheme"

const CardCamarero = ({ name, resto, restoAddress, avatar, category, loading }) => {
  const { getAvatar } = useAvatar()
  const avatarSrc = getAvatar(avatar, name || "User")

  return (
    <>
      <Title>Valora a esta tienda</Title>
      <SkeletonLoader active={loading} width="99%" height="100px" borderRadius="15px">
        <GridUser>
          <AvatarCol>
            <AvatarContainer>
              <img src={avatarSrc} alt={name} />
            </AvatarContainer>
          </AvatarCol>

          <InfoCol>
            <Name>{name}</Name>
            {restoAddress && <AddressText title={restoAddress}>{restoAddress}</AddressText>}
            <RestoText title={resto}>{resto}</RestoText>
          </InfoCol>
        </GridUser>
      </SkeletonLoader>
    </>
  )
}

export default CardCamarero

/* ========= Styled Components ========= */

const Title = styled.h6`
  font-weight: 500;
  margin: 30px 0 10px 0;
`

const theme = getHeaderTheme();

const GridUser = styled.div`
  display: grid;
  grid-template-columns: 110px 1fr;
  align-items: center;
  border: 1.5px solid ${theme.accent};
  border-radius: 15px;
  padding: 8px 20px;
  background: #fff;
  overflow: hidden;
`

const AvatarCol = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const AvatarContainer = styled.div`
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 100%;
  margin-right: 20px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    aspect-ratio: 1/1;
  }
`

const InfoCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

const Name = styled.h4`
  margin: 0 0 2px 0;
  font-weight: 700;
  color: #0f172a;
`

const RestoText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #707070;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
`

const AddressText = styled.p`
  margin: 0;
  font-size: 13px;
  color: #4b5563;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 260px;
`
